module.exports = __webpack_public_path__ + "img/layout-phone-fg.cab60c5b.png";